export default __webpack_public_path__ + "static/media/map.3ea48288.svg";